var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78317 0.666992H5.59984C6.77484 0.666992 7.7165 1.62533 7.7165 2.80116V5.64199C7.7165 6.82532 6.77484 7.77532 5.59984 7.77532H2.78317C1.6165 7.77532 0.666504 6.82532 0.666504 5.64199V2.80116C0.666504 1.62533 1.6165 0.666992 2.78317 0.666992ZM2.78317 10.2251H5.59984C6.77484 10.2251 7.7165 11.1759 7.7165 12.3592V15.2001C7.7165 16.3751 6.77484 17.3334 5.59984 17.3334H2.78317C1.6165 17.3334 0.666504 16.3751 0.666504 15.2001V12.3592C0.666504 11.1759 1.6165 10.2251 2.78317 10.2251ZM15.2166 0.666992H12.3999C11.2249 0.666992 10.2832 1.62533 10.2832 2.80116V5.64199C10.2832 6.82532 11.2249 7.77532 12.3999 7.77532H15.2166C16.3832 7.77532 17.3332 6.82532 17.3332 5.64199V2.80116C17.3332 1.62533 16.3832 0.666992 15.2166 0.666992ZM12.3999 10.2251H15.2166C16.3832 10.2251 17.3332 11.1759 17.3332 12.3592V15.2001C17.3332 16.3751 16.3832 17.3334 15.2166 17.3334H12.3999C11.2249 17.3334 10.2832 16.3751 10.2832 15.2001V12.3592C10.2832 11.1759 11.2249 10.2251 12.3999 10.2251Z",
    fill: "#B0B7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.9569ad2b982cf39c6d5b30202742e077.svg";
export { ForwardRef as ReactComponent };